export const scanRetryMaxCount = 30;

export const QuotaType = {
    Normal: "kQuotaTypeMassSendNormal",
    ProductActivity: "kQuotaTypeMassSendProductActivity",
};

export interface QuotaItem {
    original_quota: number;
    quota: number;
    str_date: string;
}

export interface QuotaDetail {
    quota_item_list: QuotaItem[];
    quota_type: string;
}

/**
 * 生成微信话题 HTML 代码
 * @param topics - 话题数组
 * @returns 生成的 HTML 字符串
 */
export function genTopicHTML(topics: string[]): string {
    if (!topics || topics.length === 0) return "";
    const rn = (): string => {
        const O = Date.now().toString(36);
        const B = Math.random().toString(36).substring(2, 8);
        return `${O}-${B}`;
    };
    const aTags = topics
        .map((topic) => {
            return `<a class="wx_topic_link" topic-id="${rn()}" style="color: #576B95 !important;" data-topic="1">#${topic}</a>`;
        })
        .join("&nbsp;");

    return `<p style="line-height: 1.75;margin: 0px 0px 24px;padding: 0px;" data-bothblock="0px"><span leaf="">${aTags}</span></p>`;
}
